import { render, staticRenderFns } from "./EditarItemDialogComponent.vue?vue&type=template&id=41488204&scoped=true"
import script from "./EditarItemDialogComponent.vue?vue&type=script&lang=js"
export * from "./EditarItemDialogComponent.vue?vue&type=script&lang=js"
import style0 from "./EditarItemDialogComponent.vue?vue&type=style&index=0&id=41488204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41488204",
  null
  
)

export default component.exports